<template>
  <v-layout>
    <v-dialog v-bind:value="show" @click:outside="$emit('close')" max-width="550px">
      <v-card>
        <v-form v-on:submit.prevent="aceptar">
          <v-card-title>
            <span class="headline">Descuento masivo</span>
          </v-card-title>

          <v-card-text>
            <!-- START FORM DIALOG -->
            <div class="row">
              <div class="col-md-12">
                <v-text-field
                  data-vv-as="descuento"
                  label="Descuento %*"
                  name="descuento"
                  v-model="item.discount_per"
                  v-validate="'required|decimal|between:0,100'"
                  hint="Este descuento reemplaza al que tengan actualmente los productos seleccionados. Los precios no se modifican."
                  persistent-hint
                  class="mb-5"
                ></v-text-field>
                <span class="red--text">{{ errors.first("descuento") }}</span>

                <!-- El alcance lo da la selección de productos; el filtro por rubro solo aplica al operar listas completas. -->
                <v-combobox
                  v-if="!selectionMode"
                  class="mt-3 mb-5"
                  v-model="item.categories"
                  data-vv-as="Rubro"
                  name="category"
                  item-text="name"
                  item-value="id"
                  v-validate="'combobox'"
                  :items="categories"
                  label="Rubros"
                  autocomplete="off"
                  chips
                  hint="Si desea puede seleccionar un rubro especifico para aplicar el descuento. Caso contrario se aplicara a todos los rubros."
                  persistent-hint
                  multiple
                ></v-combobox>
                <span v-if="!selectionMode" class="red--text">{{ errors.first("category") }}</span>

                <div class="row mt-3">
                  <div class="col-md-12">
                    <label class="subtitle-2">{{ selectionMode ? "Productos seleccionados" : "Listas de precios" }}</label>
                    <v-divider></v-divider>
                    <div v-if="selectionMode" class="mt-1">
                      <v-chip small color="primary" outlined>{{ product_presentation_ids.length }} producto(s)</v-chip>
                    </div>
                    <div v-else v-for="list of seleted" :key="list.id">
                      <v-chip small class="mt-1">{{ list.name }} </v-chip>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="$emit('close')">Cerrar</v-btn>
            <v-btn color="success" text type="submit" :loading="loading">Aceptar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import ModalGenericMixin from "@/mixins/ModalGenericMixin.vue";
import { generalService } from "@/libs/ws/generalService";
import { priceListService } from "@/libs/ws/priceListService";
import ConstantSections from "@/constants/sections";
export default {
  mixins: [ModalGenericMixin],
  props: {
    show: Boolean,
    close: Function,
    refresh: Function,
    seleted: Array,
    // Cuando viene definido, el descuento se aplica solo a estas presentaciones (vista de detalle).
    product_presentation_ids: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      item: this.defaultItem(),
      categories: [],
    };
  },
  computed: {
    selectionMode() {
      return this.product_presentation_ids != null;
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.item = this.defaultItem();
        this.$validator.reset();
      }
    },
  },
  mounted() {
    this.loadComboData();
  },
  methods: {
    defaultItem() {
      return {
        discount_per: 0,
        categories: [],
      };
    },
    loadComboData() {
      generalService.filter({}, ConstantSections.SECTION_CATEGORIES).then((response) => {
        this.categories = response.result;
      });
    },
    async aceptar() {
      if (!(await this.$validator.validateAll())) return;

      this.loading = true;
      const prices_list_ids = this.seleted.map((item) => item.id);

      const param = {
        discount_per: this.item.discount_per,
        prices_list: prices_list_ids,
      };
      if (this.selectionMode) {
        param.product_presentation_ids = this.product_presentation_ids;
      } else {
        param.categories = this.item.categories.map((item) => item.id);
      }

      priceListService
        .bulk_discount(param)
        .then((response) => {
          if (response.status === true) {
            this.$toast.success(response.msg, "OK");
            this.$emit("close", true);
            this.$emit("refresh");
            this.item = this.defaultItem();
          } else {
            if (Object.prototype.hasOwnProperty.call(response, "message")) {
              this.$toast.error(response.message, "Error");
            } else {
              this.$toast.error(response.msg, "Error");
            }
          }
        })
        .catch((e) => {
          console.log("priceListService.bulk_discount error");
          console.log(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
